<button mat-stroked-button
        class="color-blue-hover"
        (click)="click()">
  <mat-icon>search</mat-icon>
  <div [@searchBarAnimation]="opened"
       class="overflow-hidden display-inline-flex">
    <ng-container *ngIf="opened">
      <input #input
             placeholder="Search"
             appFocus
             class="flex-grow"
             [formControl]="searchCtrl"
             (focusin)="focusIn()"
             (focusout)="focusOut($event)">
      <div class="icon-clear"
           appClickStopPropagation
           (click)="clear()">
        <mat-icon>close</mat-icon>
      </div>
    </ng-container>
  </div>
</button>
